var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"parent",staticClass:"drag-parent",style:(_vm.parentStyle),on:{"mousedown":_vm.onDragStart,"mousemove":_vm.onDrag,"mouseup":_vm.onDragEnd,"mouseout":_vm.onDragEnd}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }